import "./App.css";
import Login from "./Login/Login";
import { Experimental_CssVarsProvider as MaterialCssVarsProvider, THEME_ID as MATERIAL_THEME_ID } from "@mui/material/styles";
import { CssVarsProvider as JoyCssVarsProvider } from "@mui/joy/styles";
import React from "react";
import "@fontsource/inter";
import { joyTheme, materialTheme } from "./theme";
import { Route, Routes, useNavigate } from "react-router-dom";
import Logout from "./Login/Logout";
import Layout from "./Layout";
import TicketingPortal from "./Pages/TicketingPortal";
import BuildingPortal from "./Pages/BuildingPortal";
import UsersListing from "./Pages/UsersListing";
import CheckedInTracker from "./Pages/CheckedInTracker";
import FollowUps from "./Pages/FollowUps";
import BrokenElevators from "./Pages/BrokenElevators";
import UnapprovedPackingList from "./Pages/UnapprovedPackingLists";
import ApprovedPackingLists from "./Pages/ApprovedPackingLists";
import InspectionPortal from "./Pages/InspectionPortal";
import OutOfServiceElevators from "./Pages/OutOfServiceElevators";
import MissingAnnualInspections from "./Pages/MissingAnnualInspections";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ElevatorAds from "./Pages/ElevatorAds";
import AdRender from "./Pages/AdRender";
import ProposalIssues from "./Pages/ProposalIssues";
import RingCentralAdmin from "./Pages/RingCentralAdmin";
import QboSyncAdmin from "./Pages/QboSyncAdmin";
import AutomationsAdmin from "./Pages/AutomationsAdmin";
import ServiceReports from "./Pages/ServiceReports";
import ServiceReportDetailPage from "./Pages/ServiceReportDetail";
import PasswordChange from "./Login/PasswordChange";

function App() {
	const n = useNavigate();
	const [loggedIn, setLoggedIn] = React.useState(document.cookie.includes("dynamicAuth"));
	const authenticatedRoute = (
		<Routes>
			<Route path="/logout" element={<Logout />} />
			<Route path="/alltickets" element={<TicketingPortal selected={0} />} />
			<Route path="/sales" element={<TicketingPortal selected={1} />} />
			<Route path="/" element={<BuildingPortal />} />
			<Route path="/buildingportal/*" element={<BuildingPortal />} />
			<Route path="/users" element={<UsersListing />} />
			<Route path="/checkedin" element={<CheckedInTracker />} />
			<Route path="/followups" element={<FollowUps />} />
			<Route path="/brokenelevators" element={<BrokenElevators />} />
			<Route path="/uaplists" element={<UnapprovedPackingList />} />
			<Route path="/aplists" element={<ApprovedPackingLists showFinished={false} />} />
			<Route path="/finishedlists" element={<ApprovedPackingLists showFinished={true} />} />
			<Route path="/1year" element={<InspectionPortal selected={0} />} />
			<Route path="/5year" element={<InspectionPortal selected={1} />} />
			<Route path="/alterations" element={<InspectionPortal selected={2} />} />
			<Route path="/outofserviceelevators" element={<OutOfServiceElevators />} />
			<Route path="/missingannualinspections" element={<MissingAnnualInspections />} />
			<Route path="/elevatorads" element={<ElevatorAds />} />
			<Route path="/adrender" element={<AdRender />} />
			<Route path="/proposalissues" element={<ProposalIssues selected={0} />} />
			<Route path="/proposalsmissingbuilding" element={<ProposalIssues selected={0} />} />
			<Route path="/proposalsmissingelevator" element={<ProposalIssues selected={1} />} />
			<Route path="/ringcentral" element={<RingCentralAdmin />} />
			<Route path="/qbosync" element={<QboSyncAdmin />} />
			<Route path="/automations" element={<AutomationsAdmin />} />
			<Route path="/servicereports" element={<ServiceReports />} />
			<Route path="/servicereports/:id" element={<ServiceReportDetailPage />} />
		</Routes>
	);

	return (
		<LocalizationProvider dateAdapter={AdapterDateFns}>
			<MaterialCssVarsProvider theme={{ [MATERIAL_THEME_ID]: materialTheme }}>
				<JoyCssVarsProvider theme={joyTheme}>{document.location.pathname.toLowerCase().includes("adrender") ? <AdRender /> : document.location.pathname.toLowerCase().includes("passwordchange") ? <PasswordChange /> : loggedIn ? <Layout>{authenticatedRoute}</Layout> : <Login onLogin={() => {setLoggedIn(true); n("/");}}></Login>}</JoyCssVarsProvider>
			</MaterialCssVarsProvider>
		</LocalizationProvider>
	);
}

export default App;
